export const EDUCATION_LEVEL = {
  GRADUACAO: {
    id: '019a837a-ae46-76ab-81d8-9e3db39163b0',
    label: 'Graduação'
  }
}
